import { render, staticRenderFns } from "./SortPanel.vue?vue&type=template&id=0090be96&"
import script from "./SortPanel.vue?vue&type=script&lang=js&"
export * from "./SortPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports